import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const isShadowRoot = (node) => !!node &&
    node.nodeType === Node.DOCUMENT_FRAGMENT_NODE &&
    node.toString() === '[object ShadowRoot]';
/**
 * This HOC is used to apply styles to a shadow root. It looks for style tags with data-{NAME} attribute and loads them inside the shadow root
 */
export const withShadowRootStyles = (Component, name) => (props) => {
    const ref = React.useRef(null);
    React.useEffect(() => {
        var _a;
        const root = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getRootNode();
        if (!isShadowRoot(root)) {
            return console.error('Unable to inject styles: shadow root not found.');
        }
        const styleSheets = document.querySelectorAll(`link[rel="stylesheet"][data-${name}]`);
        styleSheets.forEach((styleSheet) => {
            const styleSheetEl = document.createElement('link');
            styleSheetEl.rel = 'stylesheet';
            styleSheetEl.href = styleSheet.href;
            root.appendChild(styleSheetEl);
            // @TBD: we could remove the style from the document if it's meant only for the shadow root.
            // styleSheet.remove();
        });
        const styles = document.querySelectorAll(`style[data-${name}]`);
        styles.forEach((style) => {
            const styleEl = document.createElement('style');
            styleEl.innerHTML = style.innerHTML;
            root.appendChild(styleEl);
            // @TBD: we could remove the style from the document if it's meant only for the shadow root.
            // style.remove();
        });
    }, [ref]);
    return (_jsx("div", { [`data-${name}`]: '', ref: ref, children: _jsx(Component, Object.assign({}, props)) }));
};
